import {clsx} from 'clsx'
import {useCollapsibleSidebarContext} from '../CollapsibleSidebar/CollapsibleSidebar'
import type {ChildrenProps} from './sidebar-context'
import {Main} from './Main'
import styles from './Sidebar.module.css'
import motionStyles from './Motion.module.css'
import rowStyles from './Row.module.css'

export interface SidebarProps extends ChildrenProps {
  /** Names the navigation landmark that `Sidebar` renders around its sections. */
  'aria-label': string
}

export function SidebarContainer({
  children,
  className,
  'data-component': component = 'Sidebar',
}: ChildrenProps & {className?: string; 'data-component'?: string}) {
  const {isExpanded, visualIsExpanded, isExpansionSettled} = useCollapsibleSidebarContext()
  return (
    <div
      data-component={component}
      data-allow-wrap={isExpansionSettled || undefined}
      data-collapsed={!isExpanded || undefined}
      className={clsx(styles.Sidebar, motionStyles.Root, !visualIsExpanded && rowStyles.rail, className)}
    >
      {children}
    </div>
  )
}

export function Root({children, 'aria-label': label}: SidebarProps) {
  return (
    <SidebarContainer>
      <Main aria-label={label}>{children}</Main>
    </SidebarContainer>
  )
}
